import type { AmplifyKeys } from "@observe-tech/utils";
import { amplifyClientId, refreshTokenOf } from "./amplifyKeys";

export async function revokeRefreshToken(keys: AmplifyKeys): Promise<void> {
  const token = refreshTokenOf(keys);
  const region = import.meta.env.VITE_AWS_REGION ?? "";
  if (!token || !region) return;
  try {
    const response = await fetch(
      `https://cognito-idp.${region}.amazonaws.com/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-amz-json-1.1",
          "X-Amz-Target": "AWSCognitoIdentityProviderService.RevokeToken",
        },
        body: JSON.stringify({ Token: token, ClientId: amplifyClientId() }),
      },
    );
    if (!response.ok) {
      console.warn(
        "[revokeToken] RevokeToken refused",
        response.status,
        await response.text().catch(() => ""),
      );
    }
  } catch (error) {
    console.warn("[revokeToken] RevokeToken failed", error);
  }
}
